module.exports = __webpack_public_path__ + "img/traffic.885162db.png";